<template>
  <div class="w-5/6 lg:w-3/5 mx-auto">
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <h1 class="text-3xl text-center">用户注册协议</h1>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >一．&nbsp;<!--[endif]--><b>注册协议条款的确认和接受</b><b></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(一)&nbsp;<!--[endif]-->北京归源易生软件开发有限公司及其开发的归源易生平台(包括但不限于网页版、APP、微信小程序、企业微信等，以下简称“归源易生”或“归源易生平台”)同意按照本协议的规定及其不定时发布的操作规则提供基于互联网和移动互联网的相关服务(以下称“网络服务”)。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(二)&nbsp;<!--[endif]-->为获得网络服务,
        申请人应当认真阅读、充分理解本《协议》中各条款,
        包括免除或者限制归源易生的免责条款及对用户的权利限制条款。审慎阅读并选择接受或不接受本《协议》(未成年人应在法定监护人陪同下阅读)。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(三)&nbsp;<!--[endif]-->同意接受本协议的全部条款的,
        申请人应当按照页面上的提示完成全部的注册程序,
        并在注册程序过程中点击“同意”按钮, 否则视为不接受本《协议》全部条款,
        申请人应当终止并退出申请。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(四)&nbsp;<!--[endif]-->本《协议》可能不定期更新,
        更新后的协议条款一旦公布即代替原来的协议条款, 恕不再另行通知,
        用户可在归源易生平台查阅最新版协议条款。在修改《协议》条款后,
        如果用户不接受修改后的条款, 请立即停止使用归源易生平台提供的网络服务,
        继续使用的用户将被视为已接受了修改后的协议。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体">二．&nbsp;<!--[endif]-->服务内容</font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(一)&nbsp;<!--[endif]-->网络服务的具体内容由归源易生根据实际情况提供,
        包括但不限于医疗辅助、药品展示、中医知识学习等服务。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(二)&nbsp;<!--[endif]-->归源易生提供的网络服务包括收费和免费。对于收费服务,
        归源易生会在用户使用之前给予用户明确的提示,
        只有用户根据提示确认同意支付相关费用,
        用户才能使用该等收费服务。如用户未支付相关费用,
        则归源易生有权不向用户提供该等收费服务。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(三)&nbsp;<!--[endif]-->用户理解,
        归源易生仅提供归源易生明确承诺的网络服务,
        除此之外与相关网络服务有关的设备(如个人电脑、手机、及其他与接入互联网或移动网有关的装置)及所需的费用(如为接入互联网而支付的电话费及上网费、为使用移动网络而支付的手机费)均应由用户自行负担。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体">三．&nbsp;<!--[endif]-->用户帐号</font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(一)&nbsp;<!--[endif]-->经注册系统完成注册程序并通过身份认证的用户即为正式用户。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(二)&nbsp;<!--[endif]-->如发现用户帐号中含有不雅文字或不恰当名称的,
        归源易生保留注销其用户帐号的权利。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(三)&nbsp;<!--[endif]-->用户帐号的所有权归归源易生,
        用户完成申请注册手续后, 用户享有使用权。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(四)&nbsp;<!--[endif]-->用户有义务保证密码和帐号的安全,
        用户利用该帐号所进行的一切活动引起的任何损失或损害,
        由用户自行承担全部责任,
        归源易生不承担任何责任。如用户发现帐号遭到未授权的使用或发生其他任何安全问题,
        应立即修改账号密码并妥善保管。因黑客行为或用户的保管疏忽导致帐号非法使用,
        归源易生不承担任何责任。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(五)&nbsp;<!--[endif]-->用户帐号和密码仅由初始申请注册人使用，用户不得将自己用户账户或密码有偿或无偿以转让、出借、授权等方式提供给第三人操作和使用,
        否则用户应当自行承担因违反此要求而遭致的任何损失。违反本项约定的，归源易生并保留收回账号的权利。若因违反本约定对他人造成损害的，用户应与实际使用人承担连带赔偿责任，同时归源易生保留追究用户违约责任的权利。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(六)&nbsp;<!--[endif]-->用户帐号在丢失、遗忘密码及因合用产生使用权归属纠纷后,
        须遵照归源易生的申诉途径请求找回帐号。用户可以凭初始注册资料向归源易生申请找回帐号。归源易生的账户恢复机制仅负责识别申请用户所提资料与系统记录资料是否一致,
        而无法识别申诉人是否系帐号的真正使用权人。对用户因被他人冒名申请而致的任何损失,
        归源易生不承担任何责任, 用户知晓帐号及密码保管责任在于用户,
        归源易生并不承诺帐号丢失或遗忘密码后用户一定能通过申诉找回帐号。用户应当谨慎填写初始手机号或注册邮箱作为确认接收争议帐号的指定邮箱。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体">四．&nbsp;<!--[endif]-->使用规则</font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(一)&nbsp;<!--[endif]-->用户在使用归源易生网络服务过程中,
        必须遵循国家的相关法律法规,
        不得发布危害国家安全、色情、暴力、侵犯版权等任何合法权利等非法内容;
        也不得利用归源易生平台发布含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、或其它道德上令人反感的内容。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(二)&nbsp;<!--[endif]-->归源易生可依其合理判断,
        对违反有关法律法规或本协议约定;
        或侵犯、妨害、威胁任何人权利或安全的内容, 或者假冒他人的行为,
        归源易生有权停止传输任何前述内容,
        并有权依其自行判断对违反本条款的任何用户采取适当的法律行动,
        包括但不限于, 删除具有违法性、侵权性、不当性等内容,
        阻止其使用归源易生全部或部分网络服务,
        并且依据法律法规保存有关信息并向有关部门报告等。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(三)&nbsp;<!--[endif]-->对于经由归源易生网络服务而传送的内容,
        归源易生不保证前述内容的正确性、完整性或品质。用户在接受本服务时,
        有可能会接触到令人不快、不适当或令人厌恶的内容。在任何情况下,
        归源易生均不对任何内容负责,
        包括但不限于任何内容发生任何错误或纰漏以及衍生的任何损失或损害。归源易生有权(但无义务)自行拒绝或删除经由归源易生网络服务提供的任何内容。用户使用上述内容,
        应自行承担风险。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(四)&nbsp;<!--[endif]-->对于用户通过归源易生网络服务上传到归源易生平台上可公开获取区域的任何内容,
        用户同意归源易生在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可,
        以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容(整体或部分),
        和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(五)&nbsp;<!--[endif]-->用户通过归源易生网络服务所发布的任何内容并不反映归源易生的观点或政策,
        归源易生对此不承担任何责任。用户须对上述内容的真实性、合法性、无害性、有效性等全权负责,
        与用户所发布信息相关的任何法律责任由用户自行承担, 与归源易生无关。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(六)&nbsp;<!--[endif]-->归源易生学习爱好者仅可学习，不可用于临证。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体">五．&nbsp;<!--[endif]-->版权声明</font>
    </p>
    <p>
      <font face="标楷体"
        >归源易生提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护,
        未经相关权利人同意,
        上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行,
        或者被用于其他任何商业目的。所有以上资料或资料的任何部分仅可作为私人和非商业用途保存。归源易生不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿,
        以任何形式, 向用户或任何第三方负责。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体">六．&nbsp;<!--[endif]-->隐私保护</font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(一)&nbsp;<!--[endif]-->保护用户隐私是归源易生的一项基本政策,
        归源易生保证不对外公开或向第三方提供用户的注册资料及用户在使用网络服务时存储在归源易生内的非公开内容,
        但下列情况除外:</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.&nbsp;<!--[endif]-->事先获得用户的书面明确授权;</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >2.&nbsp;<!--[endif]-->根据有关的法律法规要求;</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >3.&nbsp;<!--[endif]-->按照相关政府主管部门的要求;</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >4.&nbsp;<!--[endif]-->为维护社会公众的利益;</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >5.&nbsp;<!--[endif]-->为维护归源易生的合法权益;</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(二)&nbsp;<!--[endif]-->为了更好地为用户提供全面服务，用户同意归源易生可将用户注册资料及使用信息提供归源易生关联公司使用。归源易生保证前述关联公司同等级地严格遵循本协议第六条第1款之隐私保护责任。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(三)&nbsp;<!--[endif]-->用户同意：归源易生或归源易生运营商的关联公司在必要时有权根据用户注册时或接受服务时所提供的联系信息（包括但不限于电子邮件地址、联系电话、联系地址、即时聊天工具账号等），通过电子邮件、电话、短信、邮寄、即时聊天、弹出页面等方式向用户发送如下信息：</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.&nbsp;<!--[endif]-->各类重要通知信息，可能包括但不限于交易单、修改密码提示等重要信息。此类信息可能对用户的权利义务产生重大的有利或不利影响，用户务必及时关注。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >2.&nbsp;<!--[endif]-->商品和服务广告、促销优惠等商业性信息。若用户不愿意接收此类信息，则可通过告知（口头或书面）的方式通知归源易生或归源易生运营商的关联公司取消发送，亦可通过归源易生或归源易生运营商关联公司所提供的相应退订功能（若有）进行退订。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >七．&nbsp;<!--[endif]-->协议的用途、更新和效力</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >(一)&nbsp;<!--[endif]-->鉴于国家法律法规不时变化及归源易生运营之需要，归源易生有权对本协议条款不时地进行修改，修改后的协议一旦被公布于归源易生平台上即告生效，并替代原来的协议。用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，则应立即停止接受归源易生依据本协议提供的服务；若用户继续使用归源易生提供的服务的，即视为同意更新后的协议。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体">八．&nbsp;<!--[endif]-->联系方式</font>
    </p>
    <p>
      <font face="标楷体"
        >当您有个人信息相关问题或其他的投诉、建议等，可以通过如下方式与归源易生联系，归源易生将尽快审核所涉及内容，并于15个工作日内对于您的问题、投诉、建议进行回复；</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <font face="标楷体">
        地址：北京市海淀区北三环西路32号恒润国际大厦602
      </font>
    </p>
    <!-- <p><font face="标楷体">投诉电话:</font></p> -->
    <p><font face="标楷体">邮箱：gyys@241210.com</font></p>
    <!-- <p><font face="标楷体">传真:</font></p> -->
    <p>
      <font face="标楷体"><br /></font>
    </p>
  </div>
</template>
<script>
export default {
  name: "Protocol",
};
</script>
